import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { attachAuthInterceptor } from './api/sessionHandler';

// Catch 401/403 from any raw axios.get/post calls in components and force
// the user back to the login screen with a single, centralized handler.
attachAuthInterceptor(axios);

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
